import React from "react";
import { Container, Row, Col } from "reactstrap";
import StackedTitle from "./StackedTitle";

function BusinessImpactSection({
  titleLines,
  paragraphs,
  image,
  imageAlt,
  accentFrom = titleLines.length - 1
}) {
  const titleGroups = [
    titleLines.map((line, index) => ({
      text: line,
      tone: index >= accentFrom ? "accent" : "default"
    }))
  ];

  return (
    <section className="supply-chain-impact-section" id="whoweare_page">
      <Container>
        <Row className="align-items-center supply-chain-impact-row">
          <Col lg="5">
            <div className="supply-chain-impact-copy">
              <StackedTitle groups={titleGroups} />
              {paragraphs.map(paragraph => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          </Col>
          <Col lg="7">
            <div className="supply-chain-impact-visual" aria-label={imageAlt}>
              <img src={image} alt={imageAlt} />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default BusinessImpactSection;
